(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["mocktail-recipe"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var forms = document.querySelectorAll('[data-mocktail-order]');
    forms.forEach(function (form) {
      var submitButton = form.querySelector('[data-mocktail-order-submit]');
      var feedback = form.querySelector('[data-mocktail-order-feedback]');
      if (!submitButton) return;

      submitButton.addEventListener('click', function () {
        var lines = form.querySelectorAll('[data-variant-id]');
        var items = [];
        lines.forEach(function (line) {
          var idAttr = line.getAttribute('data-variant-id');
          var id = parseInt(idAttr, 10);
          var qtyInput = line.querySelector('[data-quantity-input]');
          var qty = qtyInput ? parseInt(qtyInput.value, 10) : 0;
          if (id && qty > 0) {
            items.push({ id: id, quantity: qty });
          }
        });

        if (!items.length) return;

        var cartAddUrl = (window.theme && window.theme.routes && window.theme.routes.cartAdd) || '/cart/add.js';
        var cartPageUrl = (window.theme && window.theme.routes && window.theme.routes.cartPage) || '/cart';

        submitButton.disabled = true;

        fetch(cartAddUrl, {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({ items: items })
        })
          .then(function (response) {
            if (!response.ok) {
              throw new Error('cart add failed: ' + response.status);
            }
            return response.json();
          })
          .then(function () {
            if (feedback) {
              feedback.hidden = false;
              feedback.textContent = feedback.getAttribute('data-success-text') + ' ';
              var link = document.createElement('a');
              link.href = cartPageUrl;
              link.textContent = feedback.getAttribute('data-cart-link-text');
              feedback.appendChild(link);
            }
            document.dispatchEvent(new CustomEvent('cart:updated'));
          })
          .catch(function () {
            if (feedback) {
              feedback.hidden = false;
              feedback.textContent = feedback.getAttribute('data-error-text');
            }
          })
          .finally(function () {
            submitButton.disabled = false;
          });
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mocktail-recipes"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var root = document.querySelector('[data-mocktail-recipes]');
    if (!root) return;

    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-mocktail-card]'));
    var filterButtons = Array.prototype.slice.call(root.querySelectorAll('[data-filter-group]'));
    var rows = Array.prototype.slice.call(root.querySelectorAll('[data-filter-row]'));
    var emptyState = root.querySelector('[data-mocktail-empty]');

    // The four reset/default values are never hidden outright, even at zero matches: hiding a
    // default would leave nothing to land on. They render disabled and show 0 instead, the same
    // treatment the brief gives the nine spirit tabs specifically. Every other cocktail/season
    // value with zero matches under the CURRENT selection is not rendered at all.
    var DEFAULT_VALUE = { spirit: 'all', cocktail: 'popular', season: 'any' };
    var RESET_VALUE = { spirit: 'all', cocktail: 'all', season: 'any' };

    var state = { spirit: 'all', cocktail: 'popular', season: 'any' };

    // Whether `card` matches a given (possibly hypothetical) filter state. Used both for the
    // real current selection and, per button, for "what if this row were set to this value"
    // when recomputing that button's own live count.
    function effectiveMatch(card, eff) {
      var spiritOk = eff.spirit === 'all' || card.getAttribute('data-spirit') === eff.spirit;

      var cocktailOk;
      if (eff.cocktail === 'all') {
        cocktailOk = true;
      } else if (eff.cocktail === 'popular') {
        cocktailOk = card.getAttribute('data-popular') === 'true';
      } else {
        cocktailOk = card.getAttribute('data-cocktail') === eff.cocktail;
      }

      var seasonOk = eff.season === 'any' ||
        (card.getAttribute('data-seasons') || '').indexOf('|' + eff.season + '|') !== -1;

      return spiritOk && cocktailOk && seasonOk;
    }

    // Live count for one specific button: the current selection with THIS row's value swapped
    // for the button's own value, other two rows left exactly as currently selected. This is
    // what makes "choosing Gin should make the cocktail row show gin-only counts" true.
    function countForButton(group, value) {
      var eff = { spirit: state.spirit, cocktail: state.cocktail, season: state.season };
      eff[group] = value;
      var n = 0;
      cards.forEach(function (card) {
        if (effectiveMatch(card, eff)) n += 1;
      });
      return n;
    }

    // Live count for "if this whole row were reset to its most inclusive value, holding the
    // other two rows as currently selected" - used only to decide which single filter, if any,
    // is worth naming in the empty state's widen hint.
    function countIgnoring(group) {
      var eff = { spirit: state.spirit, cocktail: state.cocktail, season: state.season };
      eff[group] = RESET_VALUE[group];
      var n = 0;
      cards.forEach(function (card) {
        if (effectiveMatch(card, eff)) n += 1;
      });
      return n;
    }

    function updateEmptyState(visibleCount) {
      if (!emptyState) return;
      if (visibleCount > 0) {
        emptyState.hidden = true;
        return;
      }

      var activeLabels = rows.map(function (row) {
        var activeBtn = row.querySelector('.is-active');
        return activeBtn ? activeBtn.getAttribute('data-label') : null;
      }).filter(Boolean);

      var candidates = ['spirit', 'cocktail', 'season'].filter(function (group) {
        return countIgnoring(group) > 0;
      });

      var message = emptyState.getAttribute('data-generic-text') || '';
      if (candidates.length === 1) {
        var row = root.querySelector('[data-filter-row="' + candidates[0] + '"]');
        var groupLabel = row ? row.getAttribute('data-row-label') : candidates[0];
        var template = emptyState.getAttribute('data-widen-template') || '';
        if (template.indexOf('%group%') !== -1) {
          message = template.replace('%group%', groupLabel);
        }
      }

      var activeLine = emptyState.getAttribute('data-active-filters-label') + ': ' + activeLabels.join(', ') + '. ';
      emptyState.hidden = false;
      emptyState.textContent = activeLine + message;
    }

    // Recomputes every button's count, and its hidden/disabled state, against the currently
    // selected other two rows. Runs after every filter change and once on first load, so the
    // server rendered (static, all-35) counts only ever show in a no-JavaScript browser.
    function updateButtons() {
      filterButtons.forEach(function (btn) {
        var group = btn.getAttribute('data-filter-group');
        var value = btn.getAttribute('data-filter-value');
        var count = countForButton(group, value);
        var isDefault = DEFAULT_VALUE[group] === value || value === 'all';
        var isSpiritTab = group === 'spirit' && !isDefault;

        var countEl = btn.querySelector('.mocktail-recipes__filter-count');
        if (countEl) countEl.textContent = count;

        if (count === 0 && !isDefault && !isSpiritTab) {
          btn.hidden = true;
          return;
        }

        btn.hidden = false;
        var disable = count === 0;
        btn.disabled = disable;
        if (disable) {
          btn.setAttribute('aria-disabled', 'true');
          btn.classList.add('is-disabled');
        } else {
          btn.removeAttribute('aria-disabled');
          btn.classList.remove('is-disabled');
        }
      });
    }

    function applyFilters() {
      var visible = 0;
      cards.forEach(function (card) {
        var match = effectiveMatch(card, state);
        card.hidden = !match;
        if (match) visible += 1;
      });
      updateButtons();
      updateEmptyState(visible);
    }

    filterButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.disabled) return;
        var group = btn.getAttribute('data-filter-group');
        var value = btn.getAttribute('data-filter-value');
        state[group] = value;
        filterButtons.forEach(function (other) {
          if (other.getAttribute('data-filter-group') === group) {
            var isActive = other === btn;
            other.classList.toggle('is-active', isActive);
            other.setAttribute('aria-pressed', isActive ? 'true' : 'false');
          }
        });
        applyFilters();
      });
    });

    applyFilters();
  });

  } catch(e) { console.error(e); }
})();
})();
